<template>
    <main class="app-main app-main--loan-details view">
        <pane-header
            :tools="tools"
            :hasBackButton="true"
            title="Loan Details"
        />
        <pre v-if="false">
            {{ JSON.stringify(currentView, null, 4) }}
        </pre>
        <ui-scrollable-container>
            <ui-padding>
                <div class="loan-details__buttons">
                    <ui-button title="Renew" />
                    <ui-button title="Change due date" />
                    <ui-button title="Claim returned" />
                    <ui-button title="Lost" />
                    <ui-button title="Cancel loan" />
                </div>
            </ui-padding>
            <ui-padding>
                    <ui-details :title="loan.title" size="w250" :list="details"></ui-details>
            </ui-padding>
            <ui-padding>
                <ui-data-list
                    preset="loan_action"
                    type="results"
                    :tools="tools"
                    :maxItems="4"
                    :minItems="2"
                    :cache="true"
                    class="col-min-120"
                />
            </ui-padding>
        </ui-scrollable-container>
    </main>
</template>

<script>
    export default {
        mounted() {
            console.log('Loans view loaded', this);
            console.log('Current view', this.currentView);
            console.log('Current app', this.currentApp);
        },
        computed: {
            currentView() {
                return this.tools.currentView;
            },
            currentApp() {
                return this.tools.currentApp;
            },
            loan() {
                return this.currentView.data;
            },
            user() {
                return this.loan.includes.user;
            },
            details() {
                const { user, loan, showFee } = this;
                return [
                    {
                        label: 'Borrower',
                        value: `${user.lastname}, ${user.firstname}`,
                    },
                    {
                        label: 'Proxy Borrower',
                        value: '-',
                    },
                    'break',
                    {
                        label: 'Title',
                        value: loan.item_name,
                    },
                    {
                        label: 'Authors',
                        value: loan.authors,
                    },
                    {
                        label: 'Barcode',
                        value: loan.barcode,
                    },
                    {
                        label: 'Call number',
                        value: loan.call_number,
                    },
                    'break',
                    {
                        label: 'Location',
                        value: loan.location,
                    },
                    {
                        label: 'Item status',
                        value: loan.item_status,
                    },
                    {
                        label: 'Due date',
                        value: loan.due_date,
                    },
                    {
                        label: 'Return date',
                        value: loan.return_date,
                    },
                    {
                        label: 'Renewal count',
                        value: loan.renewal_count,
                    },
                    {
                        label: 'Claim returned',
                        value: loan.claim_returned,
                    },
                    'break',
                    {
                        label: 'Loan policy',
                        value: loan.loan_policy,
                    },
                    {
                        label: 'Loan date',
                        value: loan.loan_date,
                    },
                    {
                        label: 'Fee/fine',
                        value: loan.fee_fine,
                        onClick: showFee,
                    },
                    {
                        label: 'Request queue',
                        value: loan.request_queue,
                    },
                    {
                        label: 'lost',
                        value: loan.lost,
                    },
                ];
            },
        },
        name: 'loan-details-view',
        props: ['tools', 'viewKey'],
        methods: {
            showFee() {
                const { user, currentView } = this;

                // Go to root (user)
                this.tools.changeView({
                    key: 'users-view',
                    title: user.name,
                    owner: 'users',
                    data: {
                        pane: { ...user }
                    }
                }, null, true);

                // Add fees history to breadcrumb
                this.tools.changeView({
                    key: 'fees-view',
                    title: `Fee/fine History`,
                    owner: 'users',
                    data: {
                        includes: { user },
                    },
                });

                // Add fee details to breadcrumb
                const feeData = this.tools.generator.randomContentOfType('fee');
                this.tools.changeView({
                    key: 'fee-details-view',
                    title: feeData.breadcrumb,
                    owner: 'users',
                    data: {
                        ...feeData,
                        user,
                        includes: { user },
                    },
                });
            },
        },
    };
</script>

<style>
    .app-main.app-main--loan-details {
        flex-direction: column;
    }

    .loan-details__buttons {
        display: flex;
        align-items: center;
    }

    .loan-details__inner {
        padding: 8px;
    }

    .loan-details__buttons button {
        margin-right: 6px;
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// LoanDetailsView.vue?c54d8964